export interface Category {
  id: string;
  slug: string;
  name: string;
  description: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    id: '1',
    slug: 'mingxing-bagua',
    name: '明星八卦',
    description: '娱乐圈最新动态，明星私生活揭秘，红毯背后的故事，八卦爆料第一手资讯。',
    articleCount: 128,
  },
  {
    id: '2',
    slug: 'wanghong-heiliao',
    name: '网红黑料',
    description: '网红圈翻车现场，直播带货翻车合集，人设崩塌实录，网红八卦全掌握。',
    articleCount: 96,
  },
  {
    id: '3',
    slug: 'shehui-redian',
    name: '社会热点',
    description: '全网热议社会事件，反转剧情不断，吃瓜群众前线报道，热点追踪不间断。',
    articleCount: 156,
  },
  {
    id: '4',
    slug: 'yingshi-zongyi',
    name: '影视综艺',
    description: '热门剧集综艺爆料，片场花絮，明星片酬揭秘，影视圈不为人知的内幕。',
    articleCount: 84,
  },
  {
    id: '5',
    slug: 'qinggan-baoliao',
    name: '情感爆料',
    description: '明星恋情实锤，分手复合内幕，婚姻危机爆料，情感瓜田大丰收。',
    articleCount: 72,
  },
  {
    id: '6',
    slug: 'shejiao-meiti',
    name: '社交媒体',
    description: '微博热搜背后的故事，抖音快手热门事件，社交媒体上的精彩翻车现场。',
    articleCount: 108,
  },
];